// RadicalHelpers.jsx
import DeleteIcon from "@mui/icons-material/Delete";
import BackspaceIcon from "@mui/icons-material/Backspace";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SaveIcon from "@mui/icons-material/Save";
import DownloadIcon from "@mui/icons-material/Download";
import UploadIcon from "@mui/icons-material/Upload";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import FlipCameraAndroidIcon from "@mui/icons-material/FlipCameraAndroid";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import GridOnIcon from "@mui/icons-material/GridOn";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import EditIcon from "@mui/icons-material/Edit";
import UndoIcon from "@mui/icons-material/Undo";
import RedoIcon from "@mui/icons-material/Redo";

export const Icons = {
    Delete: DeleteIcon,
    Backspace: BackspaceIcon,
    ExpandMore: ExpandMoreIcon,
    Save: SaveIcon,
    Download: DownloadIcon,
    Upload: UploadIcon,
    UnfoldMore: UnfoldMoreIcon,
    UnfoldLess: UnfoldLessIcon,
    FlipRecipe: FlipCameraAndroidIcon,
    FlipFilled: SwapVertIcon,
    Drag: DragIndicatorIcon,
    Grid: GridOnIcon,
    Tables: ViewColumnIcon,
    Edit: EditIcon,
    Undo: UndoIcon,
    Redo: RedoIcon,
};

export const STORAGE_KEY = "radical-screen";

export const COLOR_PICAS = "#222222";
export const COLOR_TREBOLES = "#1B5E20";
export const COLOR_CORAZONES = "#DA3559";
export const COLOR_DIAMANTES = "#910B0B";
export const COLOR_JOKER = "#808080";

export const CARD_RANKS = [
    "A",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "J",
    "Q",
    "K",
];

export const CARD_SUITS = [
    { value: "♠", color: COLOR_PICAS },
    { value: "♥", color: COLOR_CORAZONES },
    { value: "♣", color: COLOR_TREBOLES },
    { value: "♦", color: COLOR_DIAMANTES },
];

export const POSITION_BASES = ["00", "10", "20", "30", "40", "50"];
export const POSITION_DIGITS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
];

export const CARD_SUIT_ALIASES = {
    pic: "♠",
    pica: "♠",
    picas: "♠",
    cora: "♥",
    corazon: "♥",
    corazón: "♥",
    corazones: "♥",
    tre: "♣",
    trebol: "♣",
    trébol: "♣",
    treboles: "♣",
    tréboles: "♣",
    dia: "♦",
    diamante: "♦",
    diamantes: "♦",
    rombo: "♦",
    rombos: "♦",
};

export const CARD_SUIT_ALIAS_GROUPS = [
    {
        symbol: "♠",
        aliases: [":pic:", ":pica:", ":picas:"],
        color: COLOR_PICAS,
    },
    {
        symbol: "♥",
        aliases: [":cora:", ":corazon:", ":corazón:", ":corazones:"],
        color: COLOR_CORAZONES,
    },
    {
        symbol: "♣",
        aliases: [":tre:", ":trebol:", ":trébol:", ":treboles:", ":tréboles:"],
        color: COLOR_TREBOLES,
    },
    {
        symbol: "♦",
        aliases: [":dia:", ":diamante:", ":diamantes:", ":rombo:", ":rombos:"],
        color: COLOR_DIAMANTES,
    },
];

export const DEFAULT_PICTOGRAMS = {
    3: {
        A: "⬅️",
        B: "⏹️",
        C: "➡️",
    },
    4: {
        A: "◀️",
        B: "⬅️",
        C: "➡️",
        D: "▶️",
    },
    6: {
        A: "↖️",
        B: "⬆️",
        C: "↗️",
        D: "↙️",
        E: "⬇️",
        F: "↘️",
    },
    8: {
        A: "⬅️",
        B: "↖️",
        C: "⬆️",
        D: "↗️",
        E: "↙️",
        F: "⬇️",
        G: "↘️",
        H: "➡️",
    },
};

export const PICTOGRAM_LAYOUT_PRESETS = {
    1: [
        {
            id: "center",
            name: "Centro",
            rows: [["A"]],
            pictograms: { A: "⏹️" },
        },
    ],
    2: [
        {
            id: "fila",
            name: "Fila",
            rows: [["A", "B"]],
            pictograms: { A: "⬅️", B: "➡️" },
        },
    ],
    3: [
        {
            id: "fila",
            name: "Fila",
            rows: [["A", "B", "C"]],
            pictograms: DEFAULT_PICTOGRAMS[3],
        },
    ],
    4: [
        {
            id: "fila",
            name: "Fila",
            rows: [["A", "B", "C", "D"]],
            pictograms: DEFAULT_PICTOGRAMS[4],
        },
        {
            id: "cross",
            name: "Cruz",
            rows: [
                [null, "A", null],
                ["B", null, "C"],
                [null, "D", null],
            ],
            pictograms: {
                A: "⬆️",
                B: "⬅️",
                C: "➡️",
                D: "⬇️",
            },
        },
        {
            id: "2Filas",
            name: "2 Filas",
            rows: [
                ["A", "B"],
                ["C", "D"],
            ],
            pictograms: {
                A: "↖️",
                B: "↗️",
                C: "↙️",
                D: "↘️",
            },
        },
        {
            id: "reloj",
            name: "Reloj",
            rows: [
                ["A", "B"],
                ["D", "C"],
            ],
            pictograms: {
                A: "↖️",
                B: "↗️",
                C: "↘️",
                D: "↙️",
            },
        },
    ],
    5: [
        {
            id: "2Filas",
            name: "2 Filas",
            rows: [
                ["A", "B", "C"],
                ["D", "E"],
            ],
            pictograms: {
                A: "↖️",
                B: "⬆️",
                C: "↗️",
                D: "↙️",
                E: "↘️",
            },
        },
        {
            id: "reloj",
            name: "Reloj",
            rows: [
                [null, "B", null],
                ["A", null, "C"],
                ["E", null, "D"],
            ],
            pictograms: {
                A: "⬅️",
                B: "⬆️",
                C: "➡️",
                D: "↘️",
                E: "↙️",
            },
        },
    ],
    6: [
        {
            id: "2Filas",
            name: "2 Filas",
            rows: [
                ["A", "B", "C"],
                ["D", "E", "F"],
            ],
            pictograms: DEFAULT_PICTOGRAMS[6],
        },
    ],
    7: [
        {
            id: "2Filas",
            name: "2 Filas",
            rows: [
                ["A", "B", "C"],
                ["D", "E", "F", "G"],
            ],
            pictograms: {
                A: "↖️",
                B: "⬆️",
                C: "↗️",
                D: "↙️",
                E: "⬇️",
                F: "⬇️",
                G: "↘️",
            },
        },
    ],
    8: [
        {
            id: "reloj",
            name: "Reloj",
            rows: [
                ["B", "C", "D"],
                ["A", null, "H"],
                ["E", "F", "G"],
            ],
            pictograms: DEFAULT_PICTOGRAMS[8],
        },
        {
            id: "2Filas",
            name: "2 Filas",
            rows: [
                ["A", "B", "C", "D"],
                ["E", "F", "G", "H"],
            ],
            pictograms: {
                A: "↖️",
                B: "⬆️",
                C: "🔼",
                D: "↗️",
                E: "↙️",
                F: "⬇️",
                G: "🔽",
                H: "↘️",
            },
        },
        {
            id: "2Filasv2",
            name: "2 Filas v2",
            rows: [
                ["A", "B", "C", "D"],
                ["E", "F", "G", "H"],
            ],
            pictograms: DEFAULT_PICTOGRAMS[8],
        },
    ],
};

export const normalizeDeckOrientation = (value) => {
    return value === "dorso" ? "dorso" : "cara";
};

export const getDisplayPosition = (position, total, deckOrientation) => {
    if (deckOrientation === "dorso") {
        return total - position + 1;
    }

    return position;
};

export const clampPositiveInt = (value, fallback = 1) => {
    const parsed = parseInt(value, 10);

    if (Number.isNaN(parsed) || parsed < 1) {
        return fallback;
    }

    return parsed;
};

export const getSafeObject = (value) => {
    return value && typeof value === "object" && !Array.isArray(value)
        ? value
        : {};
};

export const createUserPresetId = () => {
    return `user-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
};

export const normalizeHandlingText = (value, letters) => {
    const used = [];
    const raw = Array.isArray(value) ? value : String(value || "").split("");

    raw.forEach((letter) => {
        const normalizedLetter = String(letter || "")
            .trim()
            .toUpperCase();

        if (
            letters.includes(normalizedLetter) &&
            !used.includes(normalizedLetter)
        ) {
            used.push(normalizedLetter);
        }
    });

    return used.join("");
};

export const normalizeHandlingCollectOrder = (value, letters) => {
    const used = normalizeHandlingText(value, letters).split("");

    return [
        ...used,
        ...letters.filter((letter) => !used.includes(letter)),
    ].join("");
};

export const normalizeHandlingPreset = (preset, recipeDeals, recipePackets) => {
    if (!preset || typeof preset !== "object" || Array.isArray(preset)) {
        return null;
    }

    const dealsCount = clampPositiveInt(recipeDeals, 1);
    const letters = getLetters(clampPositiveInt(recipePackets, 1));
    const presetDeals = Array.isArray(preset.deals) ? preset.deals : [];

    return {
        id:
            typeof preset.id === "string" && preset.id.trim()
                ? preset.id.trim()
                : `handling-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        name:
            typeof preset.name === "string" && preset.name.trim()
                ? preset.name.trim()
                : "Versión guardada",
        deals: Array.from({ length: dealsCount }, (_, index) => {
            const deal = getSafeObject(presetDeals[index]);

            return {
                collectOrder: normalizeHandlingCollectOrder(
                    deal.collectOrder,
                    letters,
                ),
                flipPackets: normalizeHandlingText(deal.flipPackets, letters),
            };
        }),
    };
};

export const normalizeUserPreset = (preset) => {
    if (!preset || typeof preset !== "object" || Array.isArray(preset)) {
        return null;
    }

    const recipeType = preset.recipeType === "advanced" ? "advanced" : "normal";

    const basePreset = {
        id:
            typeof preset.id === "string" && preset.id.trim()
                ? preset.id
                : createUserPresetId(),
        name:
            typeof preset.name === "string" && preset.name.trim()
                ? preset.name.trim()
                : "Guardado",
        description:
            typeof preset.description === "string" ? preset.description : "",
        recipeType,
        schemaVersion: clampPositiveInt(preset.schemaVersion, 1),
        isBuiltIn: false,
    };

    if (recipeType === "advanced") {
        const data = getSafeObject(preset.data);

        return {
            ...basePreset,
            data: {
                sequence: Array.isArray(data.sequence)
                    ? data.sequence
                          .filter(
                              (step) =>
                                  step &&
                                  typeof step === "object" &&
                                  !Array.isArray(step),
                          )
                          .map((step) => ({ ...step }))
                    : [],
                values: Array.isArray(data.values)
                    ? data.values.map((value) => String(value ?? ""))
                    : [],
                deckOrientation: normalizeDeckOrientation(data.deckOrientation),
                pictogramsByPackets: {
                    ...getSafeObject(data.pictogramsByPackets),
                },
            },
        };
    }

    const nextDeals = clampPositiveInt(preset.deals, 3);
    const nextPackets = clampPositiveInt(preset.packets, 3);

    return {
        ...basePreset,
        deals: nextDeals,
        packets: nextPackets,
        deckOrientation: normalizeDeckOrientation(preset.deckOrientation),
        cardsByCode: { ...getSafeObject(preset.cardsByCode) },
        handlingPresets: Array.isArray(preset.handlingPresets)
            ? preset.handlingPresets
                  .map((handlingPreset) =>
                      normalizeHandlingPreset(
                          handlingPreset,
                          nextDeals,
                          nextPackets,
                      ),
                  )
                  .filter(Boolean)
            : [],
    };
};

export const normalizeImportedPreset = (preset) => {
    const normalized = normalizeUserPreset(preset);

    if (!normalized) {
        return null;
    }

    return {
        ...normalized,
        isBuiltIn: Boolean(preset.isBuiltIn),
    };
};

export const buildDefaultState = () => {
    return {
        deals: 3,
        packets: 3,
        deckOrientation: "cara",
        cardsByCode: {},
        pictogramsByPackets: {},
        userPresets: [],
        selectedPresetId: "custom",
        description: "",
        descriptionViewMode: "compact",
    };
};

export const loadInitialState = () => {
    const fallback = buildDefaultState();

    try {
        const raw = localStorage.getItem(STORAGE_KEY);

        if (!raw) {
            return fallback;
        }

        const parsed = JSON.parse(raw);

        const normalizedUserPresets = Array.isArray(parsed.userPresets)
            ? parsed.userPresets.map(normalizeUserPreset).filter(Boolean)
            : [];

        return {
            deals: clampPositiveInt(parsed.deals, fallback.deals),
            packets: clampPositiveInt(parsed.packets, fallback.packets),
            deckOrientation: normalizeDeckOrientation(parsed.deckOrientation),
            cardsByCode: getSafeObject(parsed.cardsByCode),
            pictogramsByPackets: getSafeObject(parsed.pictogramsByPackets),
            userPresets: normalizedUserPresets,
            selectedPresetId:
                typeof parsed.selectedPresetId === "string"
                    ? parsed.selectedPresetId
                    : "custom",
            description:
                typeof parsed.description === "string"
                    ? parsed.description
                    : "",
            descriptionViewMode:
                parsed.descriptionViewMode === "full" ? "full" : "compact",
        };
    } catch (error) {
        return fallback;
    }
};

export const getLetters = (count) => {
    return Array.from({ length: count }, (_, index) =>
        String.fromCharCode(65 + index),
    );
};

export const generateRawCodes = (packets, deals) => {
    const letters = getLetters(packets);
    const result = [];

    const buildCode = (current) => {
        if (current.length === deals) {
            result.push(current);
            return;
        }

        letters.forEach((letter) => {
            buildCode(`${current}${letter}`);
        });
    };

    buildCode("");
    return result;
};

export const complementLetter = (letter, letters) => {
    const index = letters.indexOf(letter);

    if (index === -1) {
        return letter;
    }

    return letters[letters.length - 1 - index];
};

export const getFinalCode = (rawCode, packets) => {
    const letters = getLetters(packets);
    const reversed = rawCode.split("").reverse();

    return reversed
        .map((letter, index) => {
            const isEvenPass = (index + 1) % 2 === 0;

            if (!isEvenPass) {
                return letter;
            }

            return complementLetter(letter, letters);
        })
        .join("");
};

export const getPositionTooltipText = (
    row,
    packets,
    deckOrientation,
    totalPositions,
) => {
    const letters = getLetters(packets);
    const reversed = row.rawCode.split("").reverse();
    const facePosition = row.position;
    const backPosition = totalPositions - row.position + 1;

    const steps = reversed.map((letter, index) => {
        const passNumber = index + 1;
        const transformed =
            passNumber % 2 === 0 ? complementLetter(letter, letters) : letter;

        return `Dada ${passNumber}:\t\t${letter}${
            transformed !== letter ? ` → ${transformed}` : ""
        }`;
    });

    return [
        `Posición (${deckOrientation === "cara" ? "cara" : "dorso"}):\t\t${getDisplayPosition(
            row.position,
            totalPositions,
            deckOrientation,
        )}`,
        deckOrientation === "dorso"
            ? `Numeración invertida:\t\tcara ${facePosition} → dorso ${backPosition}`
            : null,
        `Base:\t\t${row.rawCode}`,
        `Invertido:\t\t${reversed.join("")}`,
        ...steps,
        `Código final:\t${row.finalCode}`,
    ]
        .filter(Boolean)
        .join("\n");
};

export const getSchemeText = (packets, deals) => {
    return Array.from({ length: deals }, () => packets).join("x");
};

export const isPalindromeCode = (code) => {
    return code === code.split("").reverse().join("");
};

export const codeToNumeric = (code, packets) => {
    const letters = getLetters(packets);

    return String(code || "")
        .split("")
        .map((letter) => letters.indexOf(letter) + 1)
        .join("");
};

export const getDefaultPictograms = (packets) => {
    const letters = getLetters(packets);
    const preset = DEFAULT_PICTOGRAMS[packets] || {};

    return letters.reduce((acc, letter) => {
        acc[letter] = preset[letter] || "";
        return acc;
    }, {});
};

export const getPictogramsForPackets = (packets, pictogramsByPackets) => {
    const letters = getLetters(packets);
    const stored = pictogramsByPackets?.[packets] || {};
    const defaults = getDefaultPictograms(packets);

    return letters.reduce((acc, letter) => {
        acc[letter] = stored[letter] ?? defaults[letter] ?? "";
        return acc;
    }, {});
};

export const codeToPictogram = (code, pictograms) => {
    return String(code || "")
        .split("")
        .map((letter) => pictograms[letter] || letter)
        .join("");
};

export const hasAssignedCard = (value) => {
    return String(value || "").trim() !== "";
};

export const countFilledCards = (cards = {}) => {
    return Object.values(cards).filter(hasAssignedCard).length;
};

export const getVisibleCardsByCode = (rows, cards = {}) => {
    return rows.reduce((acc, row) => {
        const value = cards[row.finalCode] || "";

        if (hasAssignedCard(value)) {
            acc[row.finalCode] = value;
        }

        return acc;
    }, {});
};

export const getPresetLabel = (preset) => {
    const deckOrientation = normalizeDeckOrientation(preset.deckOrientation);

    return `${preset.name} (${countFilledCards(preset.cardsByCode)} ${getSchemeText(
        preset.packets,
        preset.deals,
    )} · ${deckOrientation === "cara" ? "cara" : "dorso"})`;
};

export const createCardsByCodeFromValues = (packets, deals, values) => {
    const presetRows = generateRawCodes(packets, deals).map(
        (rawCode, index) => ({
            position: index + 1,
            finalCode: getFinalCode(rawCode, packets),
        }),
    );

    return presetRows.reduce((acc, row, index) => {
        const value = values[index] ?? "";

        if (hasAssignedCard(value)) {
            acc[row.finalCode] = value;
        }

        return acc;
    }, {});
};

export const BUILT_IN_PRESETS = [
    {
        id: "natural-8x8",
        name: "Natural",
        deals: 2,
        packets: 8,
        isBuiltIn: true,
        deckOrientation: "cara",
        description: `Orden natural de una baraja estándar, de cara y con jokers al principio y al final.
Se incluyen posiciones vacías en las posiciones palíndricas, así como al principio y final,
para poder llevar cartas a estas mediante ⬅️➡️ y ➡️⬅️.`,
        cardsByCode: createCardsByCodeFromValues(8, 2, [
            "",
            "JOKER 1",
            "K♦",
            "Q♦",
            "J♦",
            "10♦",
            "9♦",
            "",
            "8♦",
            "7♦",
            "6♦",
            "5♦",
            "4♦",
            "3♦",
            "",
            "2♦",
            "A♦",
            "K♣",
            "Q♣",
            "J♣",
            "10♣",
            "",
            "9♣",
            "8♣",
            "7♣",
            "6♣",
            "5♣",
            "4♣",
            "",
            "3♣",
            "2♣",
            "A♣",
            "K♥",
            "Q♥",
            "J♥",
            "",
            "10♥",
            "9♥",
            "8♥",
            "7♥",
            "6♥",
            "5♥",
            "",
            "4♥",
            "3♥",
            "2♥",
            "A♥",
            "K♠",
            "Q♠",
            "",
            "J♠",
            "10♠",
            "9♠",
            "8♠",
            "7♠",
            "6♠",
            "",
            "5♠",
            "4♠",
            "3♠",
            "2♠",
            "A♠",
            "JOKER 2",
            "",
        ]),
    },
    {
        id: "mnemonica-8x8",
        name: "Mnemónica",
        description: `Mnemónica de Tamariz`,
        deals: 2,
        packets: 8,
        isBuiltIn: true,
        deckOrientation: "dorso",
        cardsByCode: createCardsByCodeFromValues(8, 2, [
            "",
            "",
            "52 - 9♦",
            "51 - A♥",
            "50 - 6♣",
            "49 - 10♦",
            "48 - Q♠",
            "",
            "47 - 7♣",
            "46 - Q♦",
            "45 - J♠",
            "44 - 9♣",
            "43 - A♣",
            "42 - 4♦",
            "",
            "41 - 7♥",
            "40 - 4♠",
            "39 - A♦",
            "38 - 10♥",
            "37 - 7♠",
            "36 - J♣",
            "",
            "35 - K♥",
            "34 - 10♠",
            "33 - 8♣",
            "32 - J♦",
            "31 - K♠",
            "30 - 5♣",
            "",
            "29 - 8♦",
            "28 - 3♥",
            "27 - 2♣",
            "26 - K♦",
            "25 - 5♦",
            "24 - 10♣",
            "",
            "23 - 6♥",
            "22 - 8♠",
            "21 - 3♠",
            "20 - J♥",
            "19 - 2♦",
            "18 - K♣",
            "",
            "17 - 9♥",
            "16 - 5♠",
            "15 - 6♠",
            "14 - 8♥",
            "13 - Q♣",
            "12 - 3♦",
            "",
            "11 - Q♥",
            "10 - 2♠",
            "9 - 9♠",
            "8 - 5♥",
            "7 - A♠",
            "6 - 6♦",
            "",
            "5 - 4♥",
            "4 - 3♣",
            "3 - 7♦",
            "2 - 2♥",
            "1 - 4♣",
            "",
            "",
        ]),
    },
    {
        id: "si-stebbins-8x8",
        name: "Si Stebbins",
        description: `Si Stebbins ♦♣♥♠ sumando 3`,
        deals: 2,
        packets: 8,
        isBuiltIn: true,
        deckOrientation: "dorso",
        cardsByCode: createCardsByCodeFromValues(8, 2, [
            "",
            "",
            "J♦",
            "8♠",
            "5♥",
            "2♣",
            "Q♦",
            "",
            "9♠",
            "6♥",
            "3♣",
            "K♦",
            "10♠",
            "7♥",
            "",
            "4♣",
            "A♦",
            "J♠",
            "8♥",
            "5♣",
            "2♦",
            "",
            "Q♠",
            "9♥",
            "6♣",
            "3♦",
            "K♠",
            "10♥",
            "",
            "7♣",
            "4♦",
            "A♠",
            "J♥",
            "8♣",
            "5♦",
            "",
            "2♠",
            "Q♥",
            "9♣",
            "6♦",
            "3♠",
            "K♥",
            "",
            "10♣",
            "7♦",
            "4♠",
            "A♥",
            "J♣",
            "8♦",
            "",
            "5♠",
            "2♥",
            "Q♣",
            "9♦",
            "6♠",
            "3♥",
            "",
            "K♣",
            "10♦",
            "7♠",
            "4♥",
            "A♣",
            "",
            "",
        ]),
    },
    {
        id: "si-stebbins-inverse-8x8",
        name: "Si Stebbins Inversa",
        description: `Si Stebbins ♠♥♣♦ restando 3`,
        deals: 2,
        packets: 8,
        isBuiltIn: true,
        deckOrientation: "dorso",
        cardsByCode: createCardsByCodeFromValues(8, 2, [
            "",
            "",
            "A♣",
            "4♥",
            "7♠",
            "10♦",
            "K♣",
            "",
            "3♥",
            "6♠",
            "9♦",
            "Q♣",
            "2♥",
            "5♠",
            "",
            "8♦",
            "J♣",
            "A♥",
            "4♠",
            "7♦",
            "10♣",
            "",
            "K♥",
            "3♠",
            "6♦",
            "9♣",
            "Q♥",
            "2♠",
            "",
            "5♦",
            "8♣",
            "J♥",
            "A♠",
            "4♦",
            "7♣",
            "",
            "10♥",
            "K♠",
            "3♦",
            "6♣",
            "9♥",
            "Q♠",
            "",
            "2♦",
            "5♣",
            "8♥",
            "J♠",
            "A♦",
            "4♣",
            "",
            "7♥",
            "10♠",
            "K♦",
            "3♣",
            "6♥",
            "9♠",
            "",
            "Q♦",
            "2♣",
            "5♥",
            "8♠",
            "J♦",
            "",
            "",
        ]),
    },

    {
        id: "rojas-y-negras-2x3",
        name: "Rojas y Negras",
        description: `Efecto: La baraja se separa en rojas y negras. Las cartas selecionadas si se realizan las dadas en orden inverso acaban en el paquete contrario.`,
        deals: 2,
        packets: 3,
        isBuiltIn: true,
        deckOrientation: "cara",
        cardsByCode: createCardsByCodeFromValues(3, 2, [
            "♠♣ Figuras",
            "♠♣ Impares",
            "",
            "♠♣ Pares",
            "Jokers",
            "♥♦ Pares",
            "",
            "♥♦ Impares",
            "♥♦ Figuras",
        ]),
    },
];

export const normalizeCardText = (value) => {
    return String(value || "").replace(/:([^:\s]+):/g, (match, alias) => {
        return CARD_SUIT_ALIASES[alias.toLowerCase()] || match;
    });
};

export const getComparableCards = (cards) => {
    return Object.entries(getSafeObject(cards))
        .map(([code, value]) => [code, normalizeCardText(value).trim()])
        .filter(([, value]) => value !== "")
        .sort(([codeA], [codeB]) => codeA.localeCompare(codeB));
};

export const areCardsEqual = (cardsA, cardsB) => {
    const comparableA = getComparableCards(cardsA);
    const comparableB = getComparableCards(cardsB);

    if (comparableA.length !== comparableB.length) {
        return false;
    }

    return comparableA.every(([code, value], index) => {
        return (
            code === comparableB[index][0] && value === comparableB[index][1]
        );
    });
};

export const presetMatchesCurrentRecipe = ({
    preset,
    safeDeals,
    safePackets,
    deckOrientation,
    currentVisibleCards,
    descriptionDraft,
}) => {
    return (
        clampPositiveInt(preset.deals, 1) === safeDeals &&
        clampPositiveInt(preset.packets, 1) === safePackets &&
        normalizeDeckOrientation(preset.deckOrientation) === deckOrientation &&
        String(preset.description || "") === String(descriptionDraft || "") &&
        areCardsEqual(preset.cardsByCode, currentVisibleCards)
    );
};

export const getRelativePosition = (
    row,
    allRows,
    cardsByCode,
    deckOrientation,
) => {
    if (!hasAssignedCard(cardsByCode[row.finalCode])) {
        return "";
    }

    const totalPositions = allRows.length;
    const currentDisplayPosition = getDisplayPosition(
        row.position,
        totalPositions,
        deckOrientation,
    );

    const occupiedPositions = allRows
        .filter((item) => hasAssignedCard(cardsByCode[item.finalCode]))
        .map((item) =>
            getDisplayPosition(item.position, totalPositions, deckOrientation),
        )
        .sort((a, b) => a - b);

    return occupiedPositions.indexOf(currentDisplayPosition) + 1;
};

export const getInverseInfo = (row, allRows, cardsByCode, deckOrientation) => {
    const inverseCode = row.finalCode.split("").reverse().join("");
    const inverseRow = allRows.find((item) => item.finalCode === inverseCode);
    const totalPositions = allRows.length;

    const currentDisplayPosition = getDisplayPosition(
        row.position,
        totalPositions,
        deckOrientation,
    );

    const inverseAbsolutePosition =
        inverseRow !== undefined && inverseRow !== null
            ? getDisplayPosition(
                  inverseRow.position,
                  totalPositions,
                  deckOrientation,
              )
            : null;

    const occupiedPositions = allRows
        .filter((item) => hasAssignedCard(cardsByCode[item.finalCode]))
        .map((item) =>
            getDisplayPosition(item.position, totalPositions, deckOrientation),
        )
        .sort((a, b) => a - b);

    const absoluteTooltip = [
        `Código actual: ${row.finalCode}`,
        `Código invertido: ${inverseCode}`,
        `Posición actual (${deckOrientation === "cara" ? "cara" : "dorso"}): ${currentDisplayPosition}`,
        `Posición inversa absoluta: ${inverseAbsolutePosition ?? "—"}`,
        "La absoluta es la fila teórica del código invertido, sin quitar la carta de su posición actual y sin compactar huecos.",
    ].join("\n");

    if (!hasAssignedCard(cardsByCode[row.finalCode])) {
        return {
            inverseAbsolutePosition,
            inverseRelativePosition: null,
            absoluteTooltip,
            relativeTooltip: [
                `Código actual: ${row.finalCode}`,
                `Código invertido: ${inverseCode}`,
                "Esta fila no tiene carta asignada.",
                "La relativa solo tiene sentido moviendo esta carta dentro de la baraja actualmente asignada, así que aquí se deja vacía.",
            ].join("\n"),
        };
    }

    const finalOccupiedPositions = occupiedPositions.filter(
        (position) => position !== currentDisplayPosition,
    );

    if (
        inverseAbsolutePosition !== null &&
        !finalOccupiedPositions.includes(inverseAbsolutePosition)
    ) {
        finalOccupiedPositions.push(inverseAbsolutePosition);
    }

    finalOccupiedPositions.sort((a, b) => a - b);

    const inverseRelativePosition =
        inverseAbsolutePosition === null
            ? null
            : finalOccupiedPositions.indexOf(inverseAbsolutePosition) + 1;

    return {
        inverseAbsolutePosition,
        inverseRelativePosition,
        absoluteTooltip,
        relativeTooltip: [
            `Código actual: ${row.finalCode}`,
            `Código invertido: ${inverseCode}`,
            `Posiciones ocupadas ahora: ${occupiedPositions.join(", ") || "ninguna"}`,
            `Para calcular la relativa, primero se libera la posición original de esta carta: ${currentDisplayPosition}`,
            `Luego se mira la posición absoluta a la que apunta el código invertido: ${inverseAbsolutePosition ?? "—"}`,
            `Posiciones ocupadas después de mover solo esta carta: ${finalOccupiedPositions.join(", ") || "ninguna"}`,
            `Dentro de esa lista compactada, la carta queda en la posición relativa: ${inverseRelativePosition ?? "—"}`,
        ].join("\n"),
    };
};

export const getOppositeCode = (code, packets) => {
    const letters = getLetters(packets);

    return String(code || "")
        .split("")
        .map((letter) => complementLetter(letter, letters))
        .join("");
};

export const remapCardsByOppositeCode = (cards, rows, packets) => {
    const next = {};

    rows.forEach((row) => {
        const value = cards[row.finalCode];

        if (hasAssignedCard(value)) {
            next[getOppositeCode(row.finalCode, packets)] = value;
        }
    });

    return next;
};

export const getCardKeyFromText = (value) => {
    const normalized = normalizeCardText(value)
        .toUpperCase()
        .replace(/\s+/g, "");

    const match = normalized.match(
        /(?:^|[^A-Z0-9])(10|[A2-9JQK])([♠♥♣♦])(?:$|[^♠♥♣♦])/,
    );

    return match ? `${match[1]}${match[2]}` : "";
};

export const getCardInfoFromText = (value) => {
    const key = getCardKeyFromText(value);

    if (!key) {
        return null;
    }

    const suit = CARD_SUITS.find((item) => key.endsWith(item.value))?.value;

    if (!suit) {
        return null;
    }

    return {
        key,
        rank: key.slice(0, -suit.length),
        suit,
    };
};

export const getCardColorInfo = (value) => {
    const text = String(value || "").trim();

    if (/^(libre|joker)$/i.test(text)) {
        return {
            mui: COLOR_JOKER,
            pdf: COLOR_JOKER,
        };
    }

    if (text.includes("♥")) {
        return {
            mui: COLOR_CORAZONES,
            pdf: COLOR_CORAZONES,
        };
    }

    if (text.includes("♦")) {
        return {
            mui: COLOR_DIAMANTES,
            pdf: COLOR_DIAMANTES,
        };
    }

    if (text.includes("♣")) {
        return {
            mui: COLOR_TREBOLES,
            pdf: COLOR_TREBOLES,
        };
    }

    return {
        mui: "text.primary",
        pdf: COLOR_PICAS,
    };
};

export const getCardTextColor = (value) => {
    return getCardColorInfo(value).mui;
};

export const getPdfCardTextColor = (value) => {
    return getCardColorInfo(value).pdf;
};
